import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { clearSession } from "./lib/session";
import "./styles.css";

/**
 * Un jeton peut etre valide localement (non expire) mais refuse par le
 * serveur : session revoquee au depart d'une employee, base changee, poste
 * deconnecte a distance. Sans ce filet, l'application affichait un ecran
 * VIDE — aucune erreur, aucun retour a la connexion. Constate au navigateur.
 */
const onUnauthorized = (error: unknown) => {
  // On inspecte la FORME de l'erreur plutot que sa classe : `instanceof` est
  // fragile des qu'une dependance est dupliquee dans le graphe de modules.
  const code = (error as { data?: { code?: string } })?.data?.code;
  const message = error instanceof Error ? error.message : "";

  if (code === "UNAUTHORIZED" || message.includes("UNAUTHORIZED")) {
    clearSession();
    window.location.reload();
  }
};

const queryClient = new QueryClient({
  queryCache: new QueryCache({ onError: onUnauthorized }),
  mutationCache: new MutationCache({ onError: onUnauthorized }),
  defaultOptions: {
    queries: {
      // Le planning bouge en permanence : on rafraichit au retour sur l'app.
      staleTime: 15_000,
      refetchOnWindowFocus: true,
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
